export const convertStrToBool = str =>
  (str && str.toString().toLowerCase() === 'true') || false;
